// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MultiLocaleInstructions_wrapper__3E8Dq","multiLocaleControls":"MultiLocaleInstructions_multiLocaleControls__210hd"};